const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Country {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new Country('/profiles/v1/countries');



// WEBPACK FOOTER //
// ./src/libraries/api/country.tsx